import { LinearProgress, LinearProgressProps } from '@mui/material';
import { FunctionComponent } from 'react';

type Props = Required<Pick<LinearProgressProps, 'value'>> &
  Omit<LinearProgressProps, 'value'>;

export const TasksProgress: FunctionComponent<Props> = ({
  classes,
  variant = 'determinate',
  ...rest
}) => {
  classes = classes ?? {};
  classes.root = 'bg-assembly-blue-50 rounded-t-xs ' + (classes.root ?? '');
  classes.bar = 'bg-assembly-blue-primary rounded-t-xs ' + (classes.bar ?? '');

  return <LinearProgress classes={classes} variant={variant} {...rest} />;
};
